var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { MTableEditField } from '@material-table/core';
var EditField = styled(MTableEditField)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.MuiFormControl-root {\n    min-width: max-content;\n\n    & input {\n      min-width: 100px;\n    }\n  }\n"], ["\n  &.MuiFormControl-root {\n    min-width: max-content;\n\n    & input {\n      min-width: 100px;\n    }\n  }\n"])));
export default EditField;
var templateObject_1;
